import { driver } from 'driver.js';

export const driverObj = driver({
    showProgress: true,
    animate: true,
    stagePadding: 10,
    overlayColor: 'rgba(0, 0, 0, 0.85)',
    smoothScroll: true,
    disableActiveInteraction: false,
    steps: [],
    onHighlighted: (_element, _step, options) => {
        const tourContext = window._tourContext;
        if (tourContext && typeof tourContext.setCurrentTourStep === 'function') {
            tourContext.setCurrentTourStep(options.state.activeIndex || 0);
        }
    }
}); 